import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap"
import { resetShouldAskToSignIn } from "../store"
import '../styles/post-modal.scss'

function AskToSignInModal() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { shouldAskToSignIn, desiredAction } = useSelector(state => state.crtUser)

  function handleToggle() {
    dispatch(resetShouldAskToSignIn())
  }

  function handleSignIn() {
    navigate('/sign-in')
    handleToggle()
  }

  return (
    <Modal id="ask-to-sign-in-modal" isOpen={shouldAskToSignIn} toggle={handleToggle}>
      <ModalBody>
        You need to sign in to be able to {desiredAction}.
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleToggle}>Maybe Later</Button>
        <Button color="primary" onClick={handleSignIn}>Sign In</Button>
      </ModalFooter>
    </Modal>
  )
}

export default AskToSignInModal
